import generateClassFormData from "./generateClassFormData";

const generateClassFormListInfo = (classList, processed_date) => {
  if (!classList) return [{ processed_date }];

  return classList.map(val => generateClassFormData(val));
};

export default generateClassFormListInfo;
